import moment from 'moment';

import { ia } from 'lib/helpers/utility';

const validationChecks = (valList) => {
  const finalErrors = [];

  valList.forEach((val) => {
    const dayEntry = {
      day: val.day,
      location: { hasErrors: false, message: '' },
      virtual: { hasErrors: false, message: '' }
    };

    const entries = { ...val };
    delete entries.day;

    Object.entries(entries).forEach(([typeKey, value]) => {
      if (ia(value)) {
        checkBreaks(value, dayEntry);
      } else {
        checkTimes(value, dayEntry, typeKey);
      }
    });

    finalErrors.push(dayEntry);
  });

  return finalErrors;
};

function checkBreaks(value, dayEntry) {
  value.forEach((item) => {
    const starts = moment(item.starts_at, 'HH:mm a');
    const ends = moment(item.ends_at, 'HH:mm a');

    if (item.starts_at != null && item.ends_at == null) {
      setError(dayEntry, `Please add an end time.`, item.id);
    }

    if (item.starts_at == null && item.ends_at != null) {
      setError(dayEntry, `Please add a start time.`, item.id);
    }

    if (starts.isValid() && ends.isValid()) {
      if (starts.isAfter(ends)) {
        setError(dayEntry, `Start time can’t be after end time.`, item.id);
      }

      if (starts.isSame(ends)) {
        setError(dayEntry, `Start time and end time can’t be the same.`, item.id);
      }
    }
  });
}

function checkTimes(value, dayEntry, typeKey) {
  const starts_at = moment(value.starts_at, 'HH:mm a');
  const ends_at = moment(value.ends_at, 'HH:mm a');

  if (value.starts_at != null && value.ends_at == null) {
    setError(dayEntry[typeKey], `Please add an end time.`);
  }

  if (value.starts_at == null && value.ends_at != null) {
    setError(dayEntry[typeKey], `Please add a start time.`);
  }

  if (starts_at.isValid() && ends_at.isValid()) {
    if (starts_at.isAfter(ends_at)) {
      setError(dayEntry[typeKey], `Start time can’t be after end time.`);
    }

    if (starts_at.isSame(ends_at)) {
      setError(dayEntry[typeKey], `Start and end times can’t be the same.`);
    }
  }
}

function setError(entry, message, breakId = null) {
  if (breakId !== null) {
    if (!entry.breaks) entry.breaks = {};
    if (!entry.breaks[breakId]) {
      entry.breaks[breakId] = message;
    }
  } else {
    if (!entry.hasErrors) {
      entry.hasErrors = true;
      entry.message = message;
    }
  }
}

export default validationChecks;
